import { useEffect, useState, useMemo } from 'react';
import { BREAKPOINTS } from '../Constants';
import { capitalize } from '../utils/utils';
import { throttle } from 'lodash';

// Return isBelow and isAbove for all breakpoint flags
// Usage: const { isAboveMd } = useBreakpointFlags();
export const useBreakpointFlags = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = throttle(() => setWidth(window.innerWidth), 50);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Memoize so we only recompute flags when width changes
  return useMemo(() => {
    return Object.keys(BREAKPOINTS).reduce((acc, key) => {
      const value = BREAKPOINTS[key];
      acc[`isAbove${capitalize(key)}`] = width >= value;
      acc[`isBelow${capitalize(key)}`] = width < value;
      return acc;
    }, {});
  }, [width]);
};
